import { ReactNode } from 'react';
import { styled } from '@mui/material';

interface SectionContainerProps {
  id?: string | null;
  children: ReactNode;
}

export function SectionContainer({ id, children }: SectionContainerProps) {
  return (
    <StyledSectionContainer
      id={id ?? undefined}
      className='section-container'
    >
      {children}
    </StyledSectionContainer>
  );
}

const StyledSectionContainer = styled('section')`
  background-color: var(--mui-palette-background-paper);
  border: 1px solid var(--mui-palette-border-secondary);
  border-radius: var(--border-radius-large);
`;
